import { Component } from '@angular/core';
import { PatentExpirationService } from './patent-expiration.service';

@Component({
  selector: 'app-patent-expiration',
  templateUrl: './patent-expiration.component.html',
  styleUrl: './patent-expiration.component.scss'
})
export class PatentExpirationComponent {
  filterOptions = [
    { label: 'Next Week Expiration', value: 'week' },
    { label: 'Next Month Expiration', value: 'month' }
  ];

  selectedFilter: string = '';
  patentsData: any[] = [];
  loading: boolean = false;

  filterType: string = '';
  dateRange: string = '';
  totalCount: number = 0;
  constructor(private patentExpirationService: PatentExpirationService) { }

  ngOnInit(): void { }

  onFilterChange() {
    if (!this.selectedFilter) return;

    this.loading = true;
    const requestPayload = { filter_type: this.selectedFilter };

    this.patentExpirationService.getPatentsExpiration(requestPayload).subscribe({
      next: (response: any) => {
        this.loading = false;
        this.patentsData = response?.data || [];
        this.filterType = response?.filter || '';
        this.dateRange = response?.date_range || '';
        this.totalCount = response?.count || 0;
      },
      error: (err) => {
        this.loading = false;
        console.error('API Error:', err);
      }
    });
  }
}
